var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeftGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3302 18.117C12.6778 18.5075 13.2413 18.5075 13.5888 18.117C13.9364 17.7265 13.9364 17.0933 13.5888 16.7028L8.87831 11.4099L13.5888 6.11702C13.9364 5.72649 13.9364 5.09333 13.5888 4.70281C13.2413 4.31228 12.6778 4.31228 12.3302 4.70281L6.9904 10.7028C6.64285 11.0933 6.64285 11.7265 6.9904 12.117L12.3302 18.117Z",
    fill: "#09984A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeftGreen);
export default __webpack_public_path__ + "static/media/icon-chevron-left-green.d592cc24d061eecf5247f70c5791aa25.svg";
export { ForwardRef as ReactComponent };